import clickOk from '../click_ok.json';

import WR_AUDIO_INSTRUCTIONS from '../../wr/wrConstants';
import wrOpeningInstruction from '../rct_opening.json';
import wrQuestionsInstruction from '../rct_accuracy_question_instruction.json';
import wrReadyInstruction from '../rct_accuracy_ready.json';
import wrAnswerHot from '../rct_accuracy_model_hot.json';
import wrAnswerPan from '../rct_accuracy_model_pan.json';
import wrAnswerRib from '../rct_accuracy_model_rib.json';
import avatarDirectionInstruction from '../rct_accuracy_direction.json';
import avatarInstructionModel from '../rct_accuracy_model_click_correct.json';
import wrPracticeStartInstruction from '../rct_accuracy_practice_start.json';
import avatarStartModel from '../rct_accuracy_model_instruction.json';
import wrPracticeCorrectResponse from '../rct_accuracy_practice_correct.json';
import wrPracticeFirstIncorrect from '../rct_accuracy_practice_incorrect_1.json';
import wrPracticeSecondIncorrect from '../rct_accuracy_practice_incorrect_2.json';
import commonReadyInstruction from '../ready_screen_common.json';

const WR_CAPTIONS = {
    [WR_AUDIO_INSTRUCTIONS.wrOpeningInstruction]: wrOpeningInstruction,
    [WR_AUDIO_INSTRUCTIONS.wrQuestionsInstruction]: wrQuestionsInstruction,
    [WR_AUDIO_INSTRUCTIONS.wrReadyInstruction]: wrReadyInstruction,
    [WR_AUDIO_INSTRUCTIONS.avatarAnswers[0]]: wrAnswerHot,
    [WR_AUDIO_INSTRUCTIONS.avatarAnswers[1]]: wrAnswerPan,
    [WR_AUDIO_INSTRUCTIONS.avatarAnswers[2]]: wrAnswerRib,
    [WR_AUDIO_INSTRUCTIONS.avatarDirectionInstruction]: avatarDirectionInstruction,
    [WR_AUDIO_INSTRUCTIONS.avatarInstructionModel]: avatarInstructionModel,
    [WR_AUDIO_INSTRUCTIONS.avatarStart]: wrPracticeStartInstruction,
    [WR_AUDIO_INSTRUCTIONS.avatarStartModel]: avatarStartModel,
    [WR_AUDIO_INSTRUCTIONS.clickOk]: clickOk,
    [WR_AUDIO_INSTRUCTIONS.commonReadyInstruction]: commonReadyInstruction,
    [WR_AUDIO_INSTRUCTIONS.correctResponseInstruction]: wrPracticeCorrectResponse,
    [WR_AUDIO_INSTRUCTIONS.firstIncorrectInstruction]: wrPracticeFirstIncorrect,
    [WR_AUDIO_INSTRUCTIONS.secondIncorrectInstruction]: wrPracticeSecondIncorrect,
};

export default WR_CAPTIONS;
